var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricitymaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7675 8.24002C18.6875 8.08003 18.5675 8.00002 18.4075 8.00002H13.6875L18.3675 0.6C18.4475 0.48 18.4475 0.320016 18.3675 0.200016C18.2875 0.0800156 18.1675 0 18.0075 0H11.6075C11.4475 0 11.3275 0.0800156 11.2475 0.200016L5.24751 12.2C5.1675 12.32 5.1675 12.48 5.24751 12.6C5.32753 12.72 5.48751 12.8 5.60751 12.8H9.7275L5.24751 23.48C5.1675 23.64 5.24751 23.84 5.4075 23.96C5.44748 24 5.5275 24 5.60751 24C5.72751 24 5.84751 23.96 5.92753 23.88L18.7275 8.67999C18.8075 8.55998 18.8475 8.4 18.7675 8.24002ZM7.00748 21.32L10.6875 12.52C10.7275 12.4 10.7275 12.28 10.6475 12.16C10.5675 12.08 10.4475 12 10.3275 12H6.2475L11.8475 0.800016H17.2875L12.5675 8.19998C12.4875 8.31998 12.4875 8.47997 12.5675 8.59997C12.6475 8.71997 12.7675 8.79998 12.9275 8.79998H17.5675L7.00748 21.32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricitymaster);
export default __webpack_public_path__ + "static/media/electricitymaster.5d62ae78bd95a4a8ad351fec7b440f61.svg";
export { ForwardRef as ReactComponent };